import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-84452a94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification-image-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "notification-circle"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "initials",
  "data-test": "notification-initials"
}
const _hoisted_5 = ["src", "alt"]

import { computed } from "vue";
import { csContext } from "../../services/cs-context";
import { NotificationApiModel } from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'notification-image',
  props: {
    notification: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "a0676f10": (imageBackgroundColour.value)
}))

const props = __props;

const teamImageUrl = computed(() => {
  if (!props.notification.teamId) {
    return "";
  }
  return csContext.userDocument.teams.find((t) => t.id === props.notification.teamId)?.imageUrl;
});

const initials = computed(() => {
  const { message } = props.notification;
  const match = message.match(/<strong>(.*?)<\/strong>/);
  const textAfterStrong = match ? match[1] : "";
  const words = textAfterStrong.split(" ");
  let firstLetters;
  if (words.length === 1) {
    // eslint-disable-next-line prefer-destructuring
    firstLetters = words[0][0];
  } else {
    const firstAndLastWords = [words[0], words[words.length - 1]];
    firstLetters = firstAndLastWords.map((word) => word[0]).join("");
  }
  return firstLetters;
});

const imageBackgroundColour = computed(() => {
  if (teamImageUrl.value) {
    return "transparent";
  }
  return "#67A6DC";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (teamImageUrl.value !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (teamImageUrl.value !== '')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: teamImageUrl.value,
                alt: "team image",
                "data-test": "notification-image"
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(initials.value), 1))
        ]))
      : _createCommentVNode("", true),
    (props.notification.actionStatus)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: 
        props.notification.actionStatus === 'Completed'
          ? require('../../assets/notifications/action-complete.svg')
          : require('../../assets/notifications/action-uncomplete.svg')
      ,
          class: "action-status",
          alt: props.notification.actionStatus,
          "data-test": "action-status"
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}
}

})